<template>
  <div class="app-container">
    <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
    <BjPage ref="BjPage"
    :query-params="queryParams"
    :col-span="colSpan"
    :get-action="queryApi"
    :serial="serial"
    :radio="radio"
    :before-reset-search="beforeResetSearch"
    :tooltip-config="{ showAll: false, enterable: false }"
    :before-query-search="beforeQuerySearch"
    :selection="selection"
    @handleSelectionChange="handleSelectionChange"
    @handleRadioChange="handleRadioChange"
    @showSetting="SortableTable.show"
    @header-dragend="SortableTable.handleHeaderDragend"
    @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.oddNumbers')" prop="orderNo">
            <BjInput v-model="queryParams.orderNo" :placeholder="$t('orderNewPatch.order')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.Order')">
            <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('ExternalOrders.Order')" />
          </el-form-item>
        </el-col>
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="receiverName">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <!-- 订单处理状态orderHandleStatus: -1暂停 0-取消中 1-取消成功 2-取消失败 3-编辑中 4-编辑成功 5-编辑失败 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('orderNewPatch.Status')" prop="orderHandleStatus">
            <BjSelectLov v-model="queryParams.orderHandleStatus" :placeholder="$t('orderNewPatch.Status')" :option-list="[{label:$t('onHoldText') ,value:'-1'}]" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-if="$store.getters.cusId" v-permission:BusinessAddThirdOrderCSGView type="primary" class="main-btn" @click="onCreate">{{ $t('addText') }}</el-button>
          <el-button v-if="$store.getters.cusId" type="primary" class="main-btn" @click="onImport">{{ $t('orderNewPatch.Import') }}</el-button>
          <!-- <el-button type="primary" class="main-btn" @click="handleNormal">{{ $t('ExternalOrders.Abnormality') }}</el-button> -->
          <BjFrontendExport
            type="primary"
            class="main-btn"
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Sales Order.csv"
          />
          <el-button type="primary" @click="onRelease">{{ $t('bulkDelRestoreText') }}</el-button>
          <el-button type="primary" @click="onCancel">{{ $t('bulkDelCancelText') }}</el-button>
        </el-col>
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span>{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'orderHandleStatus'">
                <span>{{ scope.row[col.prop] == -1 ? $t('yesText') : '' }}</span>
              </template>
              <!-- <template v-else-if="col.prop === 'failureReason'">
                {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
              </template> -->
              <template v-else-if="col.prop === 'orderTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <template v-else-if="col.prop === 'shippingMethod'">
                <el-tag v-if="['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(scope.row[col.prop])" type="success">{{ scope.row[col.prop] }}</el-tag>
                <span v-else>{{ scope.row[col.prop] }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template #header>
              {{ $t('operationText') }}
              <el-tooltip placement="top">
                <div slot="content">{{ $t('InternalOrder.ps1') }}</div>
                <i class="el-icon-question" style="color: #082dc3;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit">{{ $t('editText') }} </el-dropdown-item>
                  <el-dropdown-item command="push">{{ $t('ThreePartySalesOrder.push') }}</el-dropdown-item>
                  <el-dropdown-item command="urgent"> {{ $t('urgentText') }} </el-dropdown-item>
                  <el-dropdown-item command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.orderHandleStatus == -1" v-permission:BusinessAbnormalOrder_openOrClose command="Release">{{ $t('ThreePartySalesOrder.ReleaseHold') }}</el-dropdown-item>
                  <el-dropdown-item v-else v-permission:BusinessAbnormalOrder_openOrClose command="Hold">{{ $t('ThreePartySalesOrder.HoldOrder') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 导入弹窗 -->
    <ExcelImportDialog ref="ExcelImport" @submit="handleQuery" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi, thirdApi } from '@/api';
import ExcelImportDialog from './ExcelImportDialog.vue';
import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
  // LANG_ZH_EN_PS_LIST,
} from '@/utils/constants';
import { timeFilters } from '@/filters';

const sessionTimeOptions = { isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' };
export default {
  name: 'BusinessAbnormalOrderSTOCK',
  components: { ExcelImportDialog,
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: true,
      colSpan: 4,
      ORDER_ABNORMAL_FIVE_ROUTE_LIST,
      // LANG_ZH_EN_PS_LIST,
      queryApi: orderApi.getThirdOrderPageProcess,
      // 查询参数
      queryParamsTime_order: [],
      queryParams: {
        orderNo: null,
        operationType: Number(2),
        circulationStatus: Number(1),
        storeIdList: [],
        channel: null,
        orderStartTime: null,
        orderEndTime: null,
        cusId: null,
        payStatus: '1',
        orderHandleStatus: null,
      },
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100', export: { roles: ['admin'], options: () => this.customerList } },
        { label: this.$t('orderNewPatch.CustomerOrder'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 180, export: { prop: 'webReference' } },
        { label: this.$t('ExternalOrders.form.Channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false },
        { label: this.$t('ExternalOrders.form.Store'), prop: 'storeName', isCheck: true, disabled: false },
        { label: this.$t('ThreePartySalesOrder.OnHoldStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, export: { formatter: value => value == -1 ? this.$t('yesText') : '' } },
        // { label: this.$t('orderNewPatch.Reason'), prop: 'failureReason', isCheck: true, disabled: false, width: '185' },
        { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false, width: '135', export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
        { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false, width: '135', export: { formatter: value => timeFilters(value, sessionTimeOptions) } },
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuantity', isCheck: true, disabled: false, width: '90' },
        { label: this.$t('ExternalOrders.newAdd.ShippingMethod'), prop: 'shippingMethod', isCheck: true, disabled: false},
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
    };
  },
  computed: {
    labelList() {
      return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    // 批量取消订单按钮
    onCancel() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
        let promise = Promise.resolve();
        this.selectedRows.forEach((item) => {
          promise = promise.then(() => {
            return new Promise(resolve => {
              thirdApi.cancelThirdPartyGoods([item.outerOrderNo]).then(res => {
                if (res.failed === false) {
                  resolve();
                }
              });
            });
          });
        });
        return promise.then(() => {
          setTimeout(() => {
            this.$message.success(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }, 1500);
        });
      });
    },
    // 批量释放订单按钮
    onRelease() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const POST_DATA = this.selectedRows.map(e => e.outerOrderNo);
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
        orderApi.doThirdOrderResumeOrders(POST_DATA).then(res => {
          if (res.failed === false) {
            setTimeout(() => {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }, 2000);
          }
        });
      });
    },
    // 查看
    onView(row) {
      this.toOuterOrder(row, 'view');
    },
    _pauseOrResumeOrder(row, status) {
      orderApi.pauseOrResumeOrder({
        outerOrderNo: row.outerOrderNo,
        status,
      }).then(() => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        setTimeout(() => { this.reFresh(); }, 300);
      });
    },
    command(text, row) {
      switch (text) {
        case 'edit':
          this.toOuterOrder(row);
          break;
        case 'push':
          this.handleNormal(row);
          break;
        case 'urgent':
          this.urgentOrder(row);
          break;
        case 'cancel':
          this.onDelete(row);
          break;
        case 'Release':
          this._pauseOrResumeOrder(row, 1);
          break;
        case 'Hold':
          this._pauseOrResumeOrder(row, 0);
          break;
      }
    },
    // 跳外部详情
    toOuterOrder(item, orderType) {
      if (orderType) {
        this.$router.push({
          name: 'BusinessThirdOrderCSGView',
          query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus, type: orderType },
        });
      } else {
        this.$router.push({
          name: 'BusinessThirdOrderCSGView',
          query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus },
        });
      }
    },
    /** 异常单转正 */
    handleNormal(item) {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        // 如果是新订单1或异常订单2，调用外部订单异常转正接口
        thirdApi.thirdOrderToNormal({ outerOrderNo: item.outerOrderNo }).then(res => {
          if (res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 2000);
          }
        });
      });
    },
    // 加急
    urgentOrder(row) {
      // 第一步走加急接口
      orderApi.urgentThirdOrder({ outerOrderNo: encodeURIComponent(row.outerOrderNo) }).then(res => {
        if (res.failed === false) {
          // 第二步走转正接口
          thirdApi.thirdOrderToNormal({ outerOrderNo: row.outerOrderNo }).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 2000);
            }
          });
        }
      });
    },
    /** 新增 */
    onCreate() {
      this.$router.push({
        name: 'BusinessAddThirdOrderCSGView',
      });
    },
    /** 导入 */
    onImport() {
      this.$refs.ExcelImport.show();
    },

    // 删除
    onDelete(item) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        thirdApi.cancelThirdPartyGoods([item.outerOrderNo]).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      })
      .catch(() => {});
    },
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParams.storeIdList = null;
      this.queryParams.cusId = null;
      this.queryParams.orderHandleStatus = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
